import { chakra } from "@chakra-ui/react"

export const IsomerLogoInverted = chakra(
  (props: React.SVGProps<SVGSVGElement>) => (
    <svg
      width="86"
      height="24"
      viewBox="0 0 86 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_35_24843"
        maskUnits="userSpaceOnUse"
        x="10"
        y="7"
        width="11"
        height="17"
      >
        <path d="M10.9434 7.56909H20.8902V24H10.9434V7.56909Z" fill="white" />
      </mask>
      <g mask="url(#mask0_35_24843)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.8016 19.1929C19.8016 19.1929 18.0555 20.429 15.9168 21.7153C13.778 23.0015 12.0315 23.8666 12.0315 23.8666C11.5163 24.1764 11.0987 23.9288 11.0987 23.3143C11.0987 23.3143 10.9434 21.1362 10.9434 18.7718C10.9434 16.4068 11.0987 14.0424 11.0987 14.0424C11.0987 13.4274 11.5163 12.6777 12.0315 12.368C12.0315 12.368 13.7036 11.1769 15.9168 9.84612C18.1294 8.51433 19.8016 7.6943 19.8016 7.6943C20.3168 7.38451 20.6837 7.67861 20.7343 8.24605C20.7849 8.8145 20.8902 9.77474 20.8902 12.7886C20.8902 15.8025 20.7343 17.5184 20.7343 17.5184C20.7343 18.133 20.3168 18.8826 19.8016 19.1924"
          fill="#ACC7FA"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6085 15.2181L18.2061 14.0387C18.0168 13.8792 17.7729 13.9309 17.6646 14.1531L16.8133 15.8919L16.8143 15.8949L15.2115 14.5464C15.0223 14.3875 14.7783 14.4391 14.67 14.6613L12.0783 19.9586C11.9695 20.1808 12.054 20.2582 12.2655 20.1307L17.3012 17.1022L19.5675 15.7395C19.7791 15.6119 19.7978 15.3771 19.6085 15.2181Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.1138 13.1307C17.1138 13.3772 16.9463 13.6779 16.7393 13.8024C16.5323 13.9264 16.3647 13.8277 16.3647 13.5807C16.3647 13.3342 16.5323 13.0335 16.7393 12.909C16.9463 12.7844 17.1138 12.8837 17.1138 13.1307Z"
        fill="#B99BF9"
      />
      <mask
        id="mask1_35_24843"
        maskUnits="userSpaceOnUse"
        x="0"
        y="7"
        width="10"
        height="17"
      >
        <path d="M0 7.58569H9.94884V23.9999H0V7.58569Z" fill="white" />
      </mask>
      <g mask="url(#mask1_35_24843)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.158029 17.5187C0.158029 17.5187 0.00215179 15.8027 0.00215179 12.7888C-0.0185982 10.0083 0.11653 8.77219 0.158029 8.24677C0.199529 7.72185 0.551266 7.40751 1.09076 7.69502C1.09076 7.69502 2.76291 8.51505 4.97556 9.84582C7.18872 11.1766 8.86036 12.3677 8.86036 12.3677C9.37556 12.6775 9.7936 13.4271 9.7936 14.0421C9.7936 14.0421 9.94897 16.4066 9.94897 18.7715C9.94897 21.1359 9.7936 23.314 9.7936 23.314C9.7936 23.9285 9.37556 24.1761 8.86036 23.8658C8.86036 23.8658 7.11432 23.0012 4.97556 21.7145C3.65317 20.9169 2.35753 20.0759 1.09076 19.1926C0.575559 18.8828 0.158029 18.1332 0.158029 17.5192"
          fill="#ACC7FA"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.1636 11.5213L1.5319 9.91821C1.41448 9.8433 1.31934 9.88784 1.31934 10.0174V17.2256C1.31934 17.3557 1.41448 17.5217 1.5319 17.5961L4.1636 19.1997C4.28152 19.2746 4.37666 19.2301 4.37666 19.1005V11.8924C4.37666 11.7623 4.28152 11.5962 4.1641 11.5213H4.1636ZM8.06914 14.0801L5.23753 12.2776C5.12012 12.2026 5.02497 12.2472 5.02497 12.3768V15.3C5.02497 15.4296 5.12012 15.5951 5.23753 15.6695L8.06914 17.4726C8.18656 17.5475 8.2817 17.503 8.2817 17.3734V14.4501C8.2817 14.3205 8.18656 14.155 8.06914 14.0806"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.06857 21.7582L5.23746 19.9561C5.12005 19.8812 5.0249 19.7152 5.0249 19.5856V16.6628C5.0249 16.5333 5.12005 16.4887 5.23746 16.5631L8.06857 18.3657C8.18649 18.4406 8.28113 18.6066 8.28113 18.7362V21.6589C8.28113 21.7885 8.18649 21.8331 8.06857 21.7582Z"
        fill="#B99BF9"
      />
      <mask
        id="mask2_35_24843"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="12"
      >
        <path d="M0.888184 0H19.9326V11.1316H0.888184V0Z" fill="white" />
      </mask>
      <g mask="url(#mask2_35_24843)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5513 6.13798C19.5513 6.13798 17.8888 7.30222 15.6529 8.61123C14.2698 9.41887 12.8604 10.1804 11.4269 10.8947C10.8885 11.21 10.0124 11.211 9.47038 10.8962C9.47038 10.8962 7.3053 9.82963 5.22069 8.61983C3.13608 7.41004 1.29642 6.15317 1.29642 6.15317C0.754391 5.83832 0.75186 5.32808 1.29035 5.01222C1.29035 5.01222 2.87544 3.89353 5.18881 2.53897C6.57057 1.7291 7.98006 0.967497 9.41471 0.255544C9.9532 -0.0598128 10.6612 -0.108913 11.3718 0.253519C12.0818 0.616458 12.9645 0.988508 15.621 2.53036C18.278 4.07222 19.0619 4.6594 19.5452 4.99703C20.0291 5.33516 20.0903 5.82212 19.5513 6.13798Z"
          fill="#ACC7FA"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.0225 4.66798C6.68898 4.47461 6.74567 4.28327 7.14903 4.2443L11.3365 3.83175C11.7393 3.79227 11.9792 4.07978 11.8684 4.47006L11.3395 6.3465C11.2297 6.73728 10.8668 6.89876 10.5333 6.7059L7.0225 4.66798Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.5584 5.44659L10.2453 9.72896L9.75488 9.44397L17.068 5.16211L17.5584 5.44659Z"
        fill="#B99BF9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0229 8.40221C12.3392 8.58545 12.3407 8.88309 12.0265 9.06683C11.7127 9.25109 11.2015 9.25159 10.8857 9.06785C10.5694 8.8846 10.5679 8.58697 10.8822 8.40271C11.1959 8.21896 11.7071 8.21846 12.0229 8.40221Z"
        fill="white"
      />
      <mask
        id="mask3_35_24843"
        maskUnits="userSpaceOnUse"
        x="27"
        y="4"
        width="59"
        height="15"
      >
        <path
          d="M27.937 4.77954H85.2949V18.6294H27.937V4.77954Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask3_35_24843)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M79.3817 18.0934V9.50786C79.3817 9.27907 79.5047 9.14746 79.7415 9.14746H81.7538C81.9825 9.14746 82.1141 9.27907 82.1141 9.50786V10.3163C82.1141 10.6412 82.2897 10.7116 82.5094 10.4479C83.1215 9.7304 83.9687 9.2539 84.8997 9.10342C85.1542 9.05938 85.2944 9.2001 85.2944 9.4375V11.4319C85.2944 11.643 85.172 11.7923 84.9346 11.7923C83.1774 11.8804 82.2548 12.6012 82.2548 14.2271V18.0934C82.2548 18.3313 82.1318 18.4538 81.8945 18.4538H79.7415C79.5047 18.4538 79.3817 18.3308 79.3817 18.0934ZM74.7357 12.6012C74.9903 12.6012 75.1305 12.4605 75.0429 12.2054C74.7616 11.4324 74.0586 10.9839 73.1451 10.9839C72.2311 10.9839 71.5104 11.4233 71.1683 12.1881C71.0625 12.4428 71.2209 12.6012 71.4755 12.6012H74.7352H74.7357ZM68.1448 13.8044C68.1448 11.0978 70.1834 8.95359 73.1183 8.95359C75.7894 8.95359 77.8538 10.7728 77.8806 13.6728L77.8715 13.9274C77.8538 14.1385 77.7222 14.2701 77.5026 14.2701H71.3616C71.1328 14.2701 70.9658 14.4108 71.0362 14.6654C71.2558 15.773 72.1435 16.388 73.2154 16.388C73.9796 16.388 74.674 16.0894 75.1219 15.4829C75.2626 15.2987 75.4119 15.2283 75.6052 15.325L77.2131 16.0018C77.4327 16.0894 77.5117 16.2478 77.4155 16.4234C76.6508 17.7851 75.1573 18.6289 73.2149 18.6289C70.1399 18.6289 68.1454 16.5029 68.1454 13.8049L68.1448 13.8044ZM52.6214 18.0929V9.50786C52.6214 9.27907 52.7443 9.14746 52.9817 9.14746H55.1341C55.3715 9.14746 55.4945 9.27907 55.4945 9.50786V9.85056C55.4945 10.1755 55.6701 10.2282 55.8983 9.99128C56.496 9.35854 57.2779 8.97181 58.2183 8.97181C59.3165 8.97181 60.1688 9.33171 60.6779 10.1229C60.81 10.3426 60.9512 10.3603 61.1177 10.1583C61.7589 9.41979 62.638 8.97181 63.7094 8.97181C65.5815 8.97181 66.8118 10.0348 66.8118 12.0474V18.0934C66.8118 18.3313 66.6797 18.4538 66.4509 18.4538H64.2985C64.0612 18.4538 63.9382 18.3308 63.9382 18.0934V12.7591C63.9382 11.8363 63.4017 11.2831 62.5849 11.2831C61.6451 11.2831 61.1617 11.9857 61.1617 12.9262V18.0934C61.1617 18.3313 61.0301 18.4538 60.8014 18.4538H58.6318C58.3944 18.4538 58.2714 18.3308 58.2714 18.0934V12.7591C58.2714 11.8363 57.7532 11.2831 56.9272 11.2831C55.9869 11.2831 55.495 11.9857 55.495 12.9262V18.0934C55.495 18.3313 55.372 18.4538 55.1346 18.4538H52.9822C52.7443 18.4538 52.6219 18.3308 52.6219 18.0934L52.6214 18.0929ZM48.3793 13.7958C48.3793 12.3633 47.2896 11.3701 45.9449 11.3701C44.5921 11.3701 43.5202 12.3279 43.5202 13.7958C43.5202 15.2719 44.5921 16.2124 45.9454 16.2124C47.2896 16.2124 48.3793 15.2455 48.3793 13.7958ZM40.7964 13.7958C40.7964 10.9571 43.002 8.9713 45.954 8.9713C48.8975 8.9713 51.1203 10.9571 51.1203 13.7958C51.1203 16.6431 48.8975 18.6289 45.954 18.6289C43.002 18.6289 40.7969 16.6431 40.7969 13.7958H40.7964ZM32.6452 17.6368C32.4519 17.5224 32.4165 17.3553 32.5308 17.1443L33.3042 15.7735C33.4094 15.5624 33.5937 15.5275 33.787 15.6773C34.5694 16.1602 35.5796 16.5378 36.3175 16.5378C36.9066 16.5378 37.3018 16.3009 37.3018 15.8438C37.3018 15.2197 36.4668 15.0355 35.4829 14.6928C34.2703 14.2797 32.7945 13.7523 32.7945 11.8804C32.7945 9.88548 34.4545 8.97181 36.3706 8.97181C37.4248 8.97181 38.5316 9.23503 39.4806 9.76248C39.6916 9.87688 39.727 10.0439 39.5949 10.2545L38.8221 11.4673C38.6986 11.6607 38.5321 11.6961 38.3388 11.5817C37.7062 11.2562 36.8974 10.993 36.3352 10.993C35.8169 10.993 35.4657 11.2036 35.4657 11.5817C35.4657 12.1441 36.3529 12.3025 37.3899 12.6361C38.6374 13.0583 40.0519 13.6384 40.0519 15.5892C40.0519 17.6454 38.4618 18.6294 36.3615 18.6294C35.0527 18.6294 33.6817 18.2432 32.6452 17.6368ZM28.0954 18.0934V9.50786C28.0954 9.27907 28.2184 9.14746 28.4558 9.14746H30.591C30.8278 9.14746 30.9508 9.27907 30.9508 9.50786V18.0934C30.9508 18.3313 30.8278 18.4538 30.591 18.4538H28.4553C28.2184 18.4538 28.0954 18.3308 28.0954 18.0934ZM27.937 6.36139C27.937 5.48264 28.6577 4.77954 29.5449 4.77954C29.9655 4.77954 30.369 4.94668 30.6664 5.24419C30.9639 5.54169 31.131 5.9452 31.131 6.36594C31.131 6.78668 30.9639 7.19019 30.6664 7.4877C30.369 7.7852 29.9655 7.95234 29.5449 7.95234C28.6577 7.95234 27.9375 7.24874 27.9375 6.36139H27.937Z"
          fill="white"
        />
      </g>
    </svg>
  )
)
